import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme,
} from "@mui/material";
import { advantageListItemLabels } from "./mockData";

const AdvantageList = () => {
  const theme = useTheme();
  return (
    <List
      sx={{
        display: "flex",
        flexWrap: "wrap",
        padding: "0px",
      }}
    >
      {advantageListItemLabels.map((label, index) => (
        <ListItem
          key={index}
          sx={{
            width: "fit-content",
            padding: "12px 24px 12px 0px",
          }}
        >
          <ListItemIcon sx={{ minWidth: "16px" }}>
            <Box
              sx={{
                width: "8px",
                height: "8px",
                borderRadius: "8px",
                backgroundColor: theme.palette.primary.main,
              }}
            />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{
              variant: "subtitle1",
              sx: {
                fontWeight: "600",
              },
            }}
            sx={{
              width: "fit-content",
              "-webkit-flex": "none",
              "& .MuiListItemText-primary": {
                width: "fit-content",
                whiteSpace: "nowrap",
              },
            }}
            primary={label}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default AdvantageList;
